import React, { useState } from "react";
import s from "./AddSpares.module.scss";

import {
  Button,
  Col,
  Form,
  Image,
  Input,
  message,
  Row,
  Select,
  Upload,
} from "antd";

import { PlusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { addSpares } from "../../redux/carSlice";
import ReactQuill from "react-quill";
import { useTranslation } from "react-i18next";
import { availableOptions, manufacturersOptions } from "../../data";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const AddSpares = () => {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [activeSubcategories, setActiveSubcategories] = useState();
  const [activeCategory, setActiveCategory] = useState();
  const [activeSubCategory, setActiveSubcategory] = useState();
  const [modelsByBrand, setModelsByBrand] = useState();
  const [modelValue, setModelValue] = useState();
  const carTypes = useSelector((state) => state.cars.categories);
  const brands = useSelector((state) => state.cars.brandList);
  const models = useSelector((state) => state.cars.modelList);
  const dispatch = useDispatch();
  const [messageApi, contextHolder] = message.useMessage();
  const [value, setValue] = useState("");
  const [file, setFile] = useState([]);
  const { t } = useTranslation();
  const { width } = useWindowDimensions();

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const selectModels = (value) => {
    const data = models.filter((it) => it.brand.id === value);
    setModelsByBrand(data);
  };

  const selectSubcategories = (value) => {
    const data = carTypes.find((it) => it.id === value)?.sub_types;
    setActiveSubcategories(data);
  };

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Вы добавили объявление о продаже авто!",
    });
  };

  const sendForm = async (values) => {
    console.log("values", values);
    const data = new FormData();
    data.append("vehicle_type", values.vehicle_type);
    data.append("sub_vehicle_type", values.sub_vehicle_type);
    data.append("brand", values.brand);
    data.append("model", values.model);
    data.append("name", values.name);
    data.append("number", values.number);
    data.append("seller_comment", value);
    data.append("manufacturer", values.manufacturer);
    data.append("manufacture_date", values.manufacture_date);
    data.append("condition", values.condition);
    data.append("availability", values.availability);
    data.append("engine", values.volume);
    data.append("color", values.color);
    data.append("condition", values.condition);
    data.append("price", values.price);

    if (file && file.length > 0) {
      file.forEach((it) => {
        data.append("images", it.originFileObj);
      });
    }

    const res = await dispatch(addSpares(data));
    if (res.type === "spares/addSpares/fulfilled") {
      success();
      // form.resetFields();
      // setFile([]);
    }
  };

  const handleChange = ({ fileList: newFileList }) => setFile(newFileList);
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type='button'
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        {t("upload")}
      </div>
    </button>
  );
  return (
    <div className={s.addCar}>
      {contextHolder}
      <div className={s.contentWrapper}>
        <h2 className={s.h2}>
          <PlusCircleOutlined /> &nbsp;
          {`${t("add")} ${t("sparesSaleApplication").toLowerCase()}`}
        </h2>
        <div className={s.content}>
          <Form
            form={form}
            className={s.form}
            encType='multipart/form-data'
            layout='vertical'
            onFinish={sendForm}
          >
            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("category")}
                  name='vehicle_type'
                  rules={[
                    {
                      required: true,
                      message: t("selectCategory"),
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={t("selectCategory")}
                    options={carTypes
                      ?.filter(
                        (el) => el.id !== 4 && el.id !== 6 && el.id !== 7
                      )
                      ?.map((it) => ({
                        value: it?.id,
                        label: it?.name,
                      }))}
                    onSelect={(value) => {
                      setActiveCategory(value);
                      selectSubcategories(value);
                      setActiveSubcategory(undefined);
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("type")}
                  name='sub_vehicle_type'
                  rules={[
                    {
                      required: true,
                      message: `${t("select")} ${t("type")}`,
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={`${t("select")} ${t("type").toLowerCase()}`}
                    options={activeSubcategories?.map((it) => ({
                      value: it?.id,
                      label: it?.name,
                    }))}
                    value={activeSubCategory}
                    onSelect={(value) => setActiveSubcategory(value)}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("brand")}
                  name='brand'
                  rules={[
                    {
                      required: true,
                      message: t("selectBrand"),
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={t("selectBrand")}
                    options={brands?.map((it) => ({
                      value: it.id,
                      label: it.name,
                    }))}
                    onSelect={(value) => {
                      // setSelectedBrand(value);
                      selectModels(value);
                      setModelValue(undefined);
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("model")}
                  name='model'
                  rules={[
                    {
                      required: true,
                      message: `${t("select")} ${t("model")}`,
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={`${t("select")} ${t("model")}`}
                    value={modelValue}
                    options={modelsByBrand?.map((it) => ({
                      value: it?.id,
                      label: it?.name,
                    }))}
                    onSelect={(value) => setModelValue(value)}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("label")}
                  name='name'
                  rules={[
                    {
                      required: true,
                      message: ` ${t("select")} ${t("label").toLowerCase()}`,
                    },
                  ]}
                >
                  <input placeholder={t("label")} className={s.input} />
                </Form.Item>
              </Col>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("number")}
                  name='number'
                  rules={[
                    {
                      required: true,
                      message: ` ${t("select")} ${t("number").toLowerCase()}`,
                    },
                  ]}
                >
                  <input placeholder={t("number")} className={s.input} />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("condition")}
                  name='condition'
                  rules={[
                    {
                      required: true,
                      message: `${t("enter")} ${t("condition").toLowerCase()}`,
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={`${t("enter")} ${t(
                      "condition"
                    ).toLowerCase()}`}
                    options={[
                      {
                        value: "new",
                        label: t("new"),
                      },
                      {
                        value: "used",
                        label: t("used"),
                      },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("available")}
                  name='availability'
                  rules={[
                    {
                      required: true,
                      message: t("available"),
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={t("available")}
                    options={availableOptions?.map((it) => ({
                      value: it,
                      label: t(`availableOptions.${it}`),
                    }))}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("price")}
                  name='price'
                  rules={[
                    {
                      required: true,
                      message: t("selectPrice"),
                    },
                  ]}
                >
                  <input placeholder={t("price")} className={s.input} />
                </Form.Item>
              </Col>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("manufacturer")}
                  name='manufacturer'
                  rules={[
                    {
                      required: true,
                      message: t("selectManufacturer"),
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={t("selectManufacturer")}
                    options={manufacturersOptions?.map((it) => ({
                      value: it,
                      label: t(`manufacturersOptions.${it}`),
                    }))}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("description")}
                  name='seller_comment'
                  rules={[
                    {
                      required: true,
                      message: `${t("add")} ${t("description").toLowerCase()}`,
                    },
                  ]}
                >
                  <ReactQuill value={value} onChange={setValue} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("date")}
                  name='manufacture_date'
                  rules={[
                    {
                      required: true,
                      message: t("请提供生产日期"),
                    },
                  ]}
                >
                  <input placeholder={t("date")} className={s.input} />
                </Form.Item>
              </Col>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item label={`${t("upload")} ${t("photo").toLowerCase()}`}>
                  <Upload
                    action='https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload'
                    listType='picture-card'
                    fileList={file}
                    onPreview={handlePreview}
                    onChange={handleChange}
                    multiple={true}
                  >
                    {file.length >= 8 ? null : uploadButton}
                  </Upload>
                  {previewImage && (
                    <Image
                      wrapperStyle={{
                        display: "none",
                      }}
                      preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) =>
                          !visible && setPreviewImage(""),
                      }}
                      src={previewImage}
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row span={24} className={s.btn_row}>
              <Button className={s.btn} htmlType='submit'>
                <PlusOutlined /> &nbsp;{`${t("add")} ${t("spares")}`}
              </Button>
            </Row>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default AddSpares;
